import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { projectFormSections } from './components/project-form.sections'
import { CustomProjectFormCollapse, ProjectFormFooter } from './components'
import {
  isTaxReliefSelector,
  projectFormKindSelector,
  setBillingPayloadForCreate,
  userCompanyDetailsSelector,
} from 'src/features'

const ProjectForm: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const currenctUrl = useRouter().route
  const companyDetails = useAppSelector(userCompanyDetailsSelector)
  const selectedKind = useAppSelector(projectFormKindSelector)
  const isTaxRelief = useAppSelector(isTaxReliefSelector)
  const sections  = projectFormSections(t, selectedKind, isTaxRelief)

  useEffect(() => { // Load Billing Data
    if (companyDetails && currenctUrl.endsWith('/create')) {
      dispatch(setBillingPayloadForCreate(companyDetails))
    }
  }, [companyDetails, currenctUrl, selectedKind, dispatch])

  return (
    <>
      {sections.map((section, idx) => {
        if (!section.show) return
        return <div key={idx}>
          <CustomProjectFormCollapse
            panelKey={section.key}
            headerTitle={section.headerTitle}
            headerSubtitle={section.headerSubtitle}
          >
            <section.component />
          </CustomProjectFormCollapse>
        </div>
      })}
      <ProjectFormFooter />
    </>
  )
}

export default ProjectForm
